<template>
  <CarrotContainer :as="as">
    <CarrotCenter max="1200px" class="page-gutter" gutter="1.5rem">
      <slot />
    </CarrotCenter>
  </CarrotContainer>
</template>

<script setup lang="ts">
import { CarrotCenter, CarrotContainer } from "@carrot/design-controls-vue";

withDefaults(defineProps<{ as?: string }>(), { as: "div" });
</script>

<style scoped>
@layer kapish.components {
  .page-gutter {
    @container (max-width: 767px) {
      --center-gutter: 2.5rem !important;
    }
    @container (max-width: 599px) {
      --center-gutter: 5% !important;
    }
  }
}
</style>
